import { Link, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { ScreenTransition } from '@/components/ScreenTransition'
import { ProgressBar } from '@/components/ProgressBar'
import { ActivityRow } from '@/components/ActivityRow'
import { ACTIVITY_OPTIONS } from '@/data/activities'
import { ACTIVITY_SCREEN_QUOTE } from '@/data/quotes'
import { useQuiz } from '@/state/QuizContext'
import { pingScreen } from '@/lib/ping'

/**
 * Screen 1 - Activity. Single-select.
 *
 * The pant break-over-cuff differs between snowboard boots and ski boots, so
 * what counts as "regular" length shifts up by an inch for skiers and snow
 * play (boot height is taller, hem needs to clear it). We use this answer to
 * adjust the cm cutoffs on Screen 4 so the customer self-classifies into the
 * right band first time, instead of us silently overriding their pick later.
 */
export function ActivityScreen() {
  const { activity, setActivity } = useQuiz()
  const navigate = useNavigate()

  useEffect(() => { pingScreen('activity') }, [])

  const canContinue = activity !== null

  function handleNext() {
    if (!canContinue) return
    navigate('/questions/2')
  }

  return (
    <ScreenTransition className="fq-question">
      <div className="fq-q-inner">
        <ProgressBar current={1} total={4} />

        <header className="fq-q-header">
          <p className="fq-eyebrow">Question 1 of 4</p>
          <h2 className="fq-h2">What are you <span className="fq-accent">getting up to?</span></h2>
          <p className="fq-lede">
            Ski boots and snowboard boots break over the cuff differently, so
            the length we'd recommend shifts a touch with what you're doing.
          </p>
        </header>

        <div
          className="fq-height-list"
          role="radiogroup"
          aria-label="Activity"
        >
          {ACTIVITY_OPTIONS.map((option) => (
            <ActivityRow
              key={option.id}
              option={option}
              selected={activity === option.id}
              onSelect={() => setActivity(option.id)}
            />
          ))}
        </div>

        <div className="fq-quote-row">
          <figure className="fq-quote">
            <blockquote>"{ACTIVITY_SCREEN_QUOTE.text}" <span className="fq-quote-attr">- {ACTIVITY_SCREEN_QUOTE.attribution}</span></blockquote>
          </figure>
          <div className="fq-actions">
            <Link to="/" className="fq-back">Back</Link>
            <button
              type="button"
              className="fq-cta"
              onClick={handleNext}
              disabled={!canContinue}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </ScreenTransition>
  )
}
